
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.51 5C10.137 5 9 6.117 9 7.49A2.527 2.527 0 0011.51 10C12.883 10 14 8.863 14 7.49A2.493 2.493 0 0011.51 5zm1.318 2.783h-1.025v1.045a.293.293 0 01-.586 0V7.783h-1.045a.293.293 0 010-.586h1.045V6.172a.293.293 0 01.586 0v1.025h1.025a.293.293 0 010 .586z"}}),_c('path',{attrs:{"d":"M1.023 3l3.713 4.964L1 12h.84l3.272-3.534L7.754 12h2.862L6.694 6.757 10.172 3H9.33L6.319 6.254 3.885 3H1.023zm1.237.62h1.314l5.805 7.76H8.065L2.26 3.62z"}})])
          )
        }
      }
    